<template>
	<div class="page yarn-count-converter">
		<section id="navigation">
			<div class="container">
				<div class="content flex">
					<span @click="$router.go(-1);" class="go-back"><svg class="navigation-icon link-icon small" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 14 20"><path d="M.8 10L10.36.44 13.2 3.3 6.5 10l6.72 6.7-2.85 2.85L.8 10z"/></svg></span>
					<svg class="navigation-icon left" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 22 22"><path d="M5.5,5.5A5.5,5.5,0,1,1,11,11,5.5,5.5,0,0,1,5.5,5.5ZM0,22V19.25c0-3,5-5.5,11-5.5s11,2.48,11,5.5V22Z"/></svg>
					<span class="navigation-title">{{$t('users')}}</span>
					<div class="navigation-right">
						<router-link :to="{name: 'create-user'}"><svg class="navigation-icon link-icon" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24"><path d="M19 13h-6v6h-2v-6H5v-2h6V5h2v6h6v2z"/></svg></router-link>
					</div>
				</div>
			</div>
		</section>
		<transition name="slide-up" mode="out-in" appear>
			<section class="main no-padding-top no-padding-bottom">
				<FilteredSearch :loaded="usersLoaded" :list="users" :click="userClick" :customText="userText" :placeholder="$t('search')" :deleteAction="deleteAction" :filterAttributes="filterAttributes"/>
			</section>
		</transition>
	</div>
</template>

<script>
import FilteredSearch from '@/components/FilteredSearch.vue'

export default {
	data() {
		return {
			users: [],
			usersLoaded: false,
			filterAttributes: [
				{attribute: 'name', text: this.$t('name')},
				{attribute: 'username', text: this.$t('username')},
				{attribute: 'email', text: this.$t('email')},
			],
		};
	},
	created() {
		let self = this;
		axios.get(`/admin/users`)
		.then((response) => {
			// this.users = response.data.response.users.map(obj=> ({...obj, text : ''}));
			self.users = [...response.data.response.users];
			self.usersLoaded = true;
		})
		.catch(err => {
			console.log(err);
		});
	},
	methods: {
		userClick(item) {
			this.$router.push({name: 'user', params: {id: item.id}});
		},
		userText(item) {
			return `${item.name}`
		},
		deleteAction(selected) {
			return new Promise((resolve, reject) => {
				let self = this;
				let ids = selected.map(o => o.id);

				let onConfirm = (buttonIndex) => {
					if (buttonIndex == 1) {
						Promise.all(ids.map(id => {
							return new Promise((resolve, reject) => {
								axios.delete(`/admin/users/${id}`)
								.then((response) => {
									self.users = self.users.filter(o => o.id != id);
									resolve();
								})
								.catch((err) => {
									let resp = err.response;
									reject(resp);
								});
							});
						}))
						.then(() => {
							self.$snack.success(self.$tc('user-deleted-successfully', ids.length));
							return resolve();
						})
						.catch((err) => {
							self.$snack.danger(self.$t('delete-error'));

							if (navigator.vibrate){
								navigator.vibrate([500]);
							}
							return reject();
						});
					}
				}
				let message = self.$tc('delete-user-confirm', ids.length, {count: ids.length});
				if (navigator.notification) {
					navigator.notification.confirm(
						message,	// message
						onConfirm,						// callback to invoke with index of button pressed
						this.$t('delete-yarn'),			// title
						[this.$t('confirm'),
						this.$t('cancel')]	// buttonLabels
					);
				} else {
					if (confirm(message)) onConfirm(1);
				}
			});
		},
	},
	components: {
		FilteredSearch
	},
}
</script>